import {
  related,
  sourceIds,
} from './trophies__combat-readiness-sixth-ability-slot.mdx';

export { sourceIds, related };
export const quickAnswer =
  '完成主线后，在 The Unknown 完成 Pope’s Research，领取允许额外战斗能力选择的奖励。';

## 为什么只有五个可选分组

额外战斗能力与通关后进度相关。仅在每个共振者分组选择一项，不等于已经满足成就要求。

## 需要完成什么

主线结束后完成 The Unknown 的 **Pope’s Research**。已发布能力资料将奖励标为 **Resonant Combat Token**，允许从之前的选择组再取得一项能力。消费前请核对游戏当前版本中的说明。

## 在哪里配置第六个能力

领奖后回到游戏战斗能力配置，选择额外能力。本站模拟器采用五组各选一项的模型，不模拟这一额外解锁。

## Combat Readiness 检查清单

- 完成主线。
- 完成研究任务并领取奖励。
- 在游戏内解锁额外战斗选择。
- 检查配装与成就状态，不以网站保存链接代替确认。
